<script>
  import ContentDataStore from '../stores/ContentDataStore.js'
</script>

<style>
  p {
    margin: 0 auto;
    font-size: 14px;
    letter-spacing: 0.06em;
    line-height: 1.6;
    word-break: keep-all;
    padding-bottom: 0.5rem;
  }

  .intro-author-info {
    padding: 0 1rem 0.75rem 1rem;
  }

  .author-outer {
    display: flex;
    justify-content: center;
    margin-top: 3rem;
    width: 100%;
  }

  .author-wrap {
    width: max-content;     /* 桌面:自動貼合「最長那一行」的寬度 */
    max-width: 100%;        /* 防止視窗很窄時撐破父容器 */
    overflow-x: hidden;
  }

  /* 手機:最長那行(製作團隊)放不下整段,改用窄一點的固定寬度,
     讓所有行都優雅換行對齊;窄欄內文字也改置中,視覺更平衡 */
  @media (max-width: 640px) {
    .author-wrap {
      width: 280px;
    }
    .intro-author-info {
      text-align: center;
    }
  }

  @media (min-width: 640px) {
    .author-outer {
      margin-top: 3rem;
    }
  }
</style>

<div class="author-outer">
  <div class="author-wrap">
    <div class="intro-author-info">
      <p>
        {@html $ContentDataStore.author}
      </p>
      <p>{$ContentDataStore.sub_editor}</p>
      <p>{$ContentDataStore.published_date}</p>
    </div>
  </div>
</div>
